import { Route, Routes, Navigate } from "react-router-dom";
import AuthLayout from "components/AuthLayout";
import Login from "components/Login";
import { useSelector } from "react-redux";
import Dashboard from "components/Dashboard";
import Profile from "components/Profile";
import Register from "components/Register";
import RegistrationConfirm from "components/RegistrationConfirm";
import Logout from "components/Common/Logout";
import TestRides from "components/Dashboard/TestRides";
// import EolTests from "./components/Dashboard/EOL-V1/Tests";
// import EolAnalytics from "./components/Dashboard/EOL-V1/Analytics";
import EolTestsV2 from "components/Dashboard/EOL/Tests";
import EolAnalytics from "components/Dashboard/EOLAnalytics";
import { ORG_TYPES, ROUTES } from "components/Common/Constants";
import ForgotPassword from "components/ForgotPassword";
import ChangePassword from "components/ChangePassword";
import FleetMonitor from "components/Dashboard/FleetMonitor";
import TestRidesComparison from "components/Dashboard/TestRidesComparison";
import DealerSlideShow from "components/Dealers/SlideShow";
import ProductHealth from "components/Displays/ProductHealth";
import DealerService from "components/Dealers/Service";
import DealerExecutive from "components/Dealers/Executive";
import DealerLayout from "components/Dealers/Layout";
import Home from "components/Home";
import DealerPerformance from "components/Dealers/Performance";
import AccessDenied from "components/AccessDenied";
import ExportFile from "components/Export";
import BatteryPerformance from "components/Dashboard/BatteryPerformance";
import SendOtp from "components/Login/sendOtp";
import VerifyOtp from "components/Login/verifyOtp";
import Alerts from "components/Alerts";
import UnauthLayout from "components/UnauthLayout";
import VehicleAnalytics from "components/Dashboard/VehicleAnalytics";
// import Competitors from "components/Dashboard/Competitors";
import MarketPulse from "components/Dashboard/MarketPulse";
// import MarketPulse from "components/Dashboard/MarketPulseV2";
import OperationalParameters from "components/Displays/OperationalParameters";
import VehicleInformation from "components/Dashboard/VehicleInformation";
import FleetAnalytics from "components/Dashboard/FleetAnalytics";
import SpeakwithData from "components/Dashboard/SpeakwithData";
import VehicleHealth from "components/Dashboard/VehicleHealth";
import { useDocumentTitle } from "hooks/useDocumentTitle";

const Routing = () => {
  document.title =  useDocumentTitle();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isDealerLayout = useSelector((state) => state.auth.dealerLayout);
  const isDealerSlideShow = useSelector((state) => state.auth.dealerSlideShow);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));

  const renderIfLoggedIn = (component) => {
    return isLoggedIn ? (
      userDetails?.currentOrganisation?.type !== ORG_TYPES.DEALER ? (
        <AuthLayout>{component}</AuthLayout>
      ) : isDealerSlideShow ? (
        component
      ) : (
        <DealerLayout>{component}</DealerLayout>
      )
    ) : (
      <Navigate to="/login" replace={true} />
    );
  };

  const renderIfNotLoggedIn = (component) => {
    return !isLoggedIn ? component : <Navigate to="/" replace={true} />;
  };

  return (
    <Routes>
      {isDealerLayout ? (
        <Route
          path={ROUTES.DEFAULT.link}
          exact
          element={renderIfLoggedIn(<DealerExecutive />)}
        />
      ) : (
        <Route
          path={ROUTES.DEFAULT.link}
          exact
          element={renderIfLoggedIn(<Dashboard />)}
        />
      )}
      <Route
        path={ROUTES.DEALER_EXECUTIVE.link}
        exact
        element={renderIfLoggedIn(<DealerExecutive />)}
      />
      <Route
        path={ROUTES.DEALER_SLIDESHOW.link}
        exact
        element={renderIfLoggedIn(<DealerSlideShow />)}
      />
      <Route
        path={ROUTES.DEALER_PERFORMANCE.link}
        exact
        element={renderIfLoggedIn(<DealerPerformance />)}
      />
      <Route
        path={ROUTES.EXPORT.link}
        exact
        element={renderIfLoggedIn(<ExportFile />)}
      />
      <Route
        path={ROUTES.HOME.link}
        exact
        element={renderIfLoggedIn(<Home />)}
      />
      <Route
        path={ROUTES.ACCESS_DENIED.link}
        exact
        element={renderIfLoggedIn(<AccessDenied />)}
      />
      <Route
        path={ROUTES.PRODUCT_HEALTH.link}
        exact
        element={renderIfLoggedIn(<ProductHealth />)}
      />
      <Route
        path={ROUTES.VEHICLE_ANALYTICS.link}
        exact
        element={renderIfLoggedIn(<VehicleAnalytics />)}
      />
      <Route
        path={ROUTES.MARKET_PULSE.link}
        exact
        element={renderIfLoggedIn(<MarketPulse />)}
      />
      <Route
        path={ROUTES.VEHICLE_HEALTH.link}
        exact
        element={renderIfLoggedIn(<VehicleHealth />)}
      />
      <Route
        path={ROUTES.VEHICLE_INFORMATION.link}
        exact
        element={renderIfLoggedIn(<VehicleInformation />)}
      />
      <Route
        path={ROUTES.BATTERY_PERFORMANCE.link}
        exact
        element={renderIfLoggedIn(<BatteryPerformance />)}
      />
      <Route
        path={ROUTES.ALERTS.link}
        exact
        element={renderIfLoggedIn(<Alerts />)}
      />
      <Route
        path={ROUTES.OPERATIONAL_PARAMETERS.link}
        exact
        element={renderIfLoggedIn(<OperationalParameters />)}
      />
      <Route
        path={ROUTES.DEALER_SERVICE.link}
        exact
        element={renderIfLoggedIn(<DealerService />)}
      />
      <Route
        path={ROUTES.PROFILE.link}
        exact
        element={renderIfLoggedIn(<Profile />)}
      />
      <Route
        path={ROUTES.REGISTER.link}
        exact
        element={renderIfLoggedIn(<Register />)}
      />
      <Route
        path={ROUTES.TEST_RIDES.link}
        exact
        element={renderIfLoggedIn(<TestRides />)}
      />
      <Route
        path={ROUTES.LOGOUT.link}
        exact
        element={renderIfLoggedIn(<Logout />)}
      />
      <Route
        path={ROUTES.FORGOT_PASSWORD.link}
        element={renderIfNotLoggedIn(
          <UnauthLayout>
            <ForgotPassword />
          </UnauthLayout>
        )}
      />
      <Route
        path={ROUTES.CHANGE_PASSWORD.link}
        element={renderIfNotLoggedIn(
          <UnauthLayout>
            <ChangePassword />
          </UnauthLayout>
        )}
      />
      <Route
        path={ROUTES.LOGIN.link}
        exact
        element={renderIfNotLoggedIn(
          <UnauthLayout>
            <Login />
          </UnauthLayout>
        )}
      />
      <Route
        path={ROUTES.SEND_OTP.link}
        exact
        element={renderIfNotLoggedIn(
          <UnauthLayout>
            <SendOtp />
          </UnauthLayout>
        )}
      />
      <Route
        path={ROUTES.VERIFY_OTP.link}
        exact
        element={renderIfNotLoggedIn(
          <UnauthLayout>
            <VerifyOtp />
          </UnauthLayout>
        )}
      />
      <Route
        path={ROUTES.CONFIRM_REGISTRATION.link}
        element={renderIfNotLoggedIn(
          <UnauthLayout>
            <RegistrationConfirm />
          </UnauthLayout>
        )}
      />
      <Route
        path={ROUTES.EOL_TESTS.link}
        exact
        element={renderIfLoggedIn(<EolTestsV2 />)}
      />
      <Route
        path={ROUTES.EOL_ANALYTICS.link}
        exact
        element={renderIfLoggedIn(<EolAnalytics />)}
      />
      <Route
        path={ROUTES.FLEET_MONITOR.link}
        exact
        element={renderIfLoggedIn(<FleetMonitor />)}
      />
      <Route
        path={ROUTES.FLEET_ANALYTICS.link}
        exact
        element={renderIfLoggedIn(<FleetAnalytics />)}
      />
      <Route
        path={ROUTES.TEST_RIDES_COMPARISON.link}
        exact
        element={renderIfLoggedIn(<TestRidesComparison />)}
      />
      <Route
        path={ROUTES.SPEAK_WITH_DATA.link}
        exact
        element={renderIfLoggedIn(<SpeakwithData />)}
      />
    </Routes>
  );
};

export default Routing;
